<div>
	<app-dropdown
		label="Interest/estate"
		[itemGroups]="interestEstateOptions"
		[ngModel]="interestEstate_()"
		(onSelect)="setInterestEstate($event)"
		[testHook]="testHooks.InterestEstateDropdown"
	/>
</div>
